import Swiper from 'swiper'
import { A11y, Keyboard, Navigation } from 'swiper/modules'

import Component, { loadComponent } from '../../../assets/scripts/modules/component.js'
import applyMappingsToClone from '../../../assets/scripts/utilities/apply-mappings-to-clone.js'

const SWIPER_OPTIONS = {
  createElements: true,
  slidesPerView: 1,
  spaceBetween: 0,
  modules: [Navigation, Keyboard, A11y],
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  keyboard: {
    enabled: true,
    onlyInViewport: true,
    pageUpDown: false,
  },
  a11y: {
    enabled: true,
    scrollOnFocus: true,
    containerMessage: 'Carousel met personen',
    firstSlideMessage: 'Dit is de eerste dia',
    lastSlideMessage: 'Dit is de laatste dia',
    nextSlideMessage: 'Volgende dia',
    prevSlideMessage: 'Vorige dia',
    paginationBulletMessage: 'Ga naar dia {{index}}',
    slideLabelmessage: '{{index}} / {{slidesLength}}',
  },
}

export default class CharacterCardCarouselComponent extends Component {
  init() {
    this.swiperContainer = this.element.querySelector('.swiper')
    this.slideContainer = this.element.querySelector('.swiper-wrapper')
    this.template = this.element.querySelector('.character-card-carousel__template')

    if (!this.swiperContainer || !this.slideContainer || !this.template) {
      return
    }

    this.excludeIds = (this.element.dataset?.excludeIds || '').split(',')
    this.swiper = null
    this.swiperOptions = { ...SWIPER_OPTIONS }

    window.addEventListener('fetch-data', event => this.onFetchData(event))
  }

  reinit() {
    this.onFetchData({ detail: window.fetchData })
  }

  onFetchData(event = { detail: null }) {
    if (!event?.detail) {
      return
    }

    this.data = { ...event.detail }

    const orderMap = new Map((this.data.character_order || []).map((id, index) => [id, index]))

    this.characters = this.data.characters?.length ? [...this.data.characters] : []
    this.characters.sort((a, b) => (orderMap.get(a.id) ?? Infinity) - (orderMap.get(b.id) ?? Infinity)) // Sort characters based on order
    this.characters = this.characters.filter(character => character.show_in_character_screen && character.is_available) // Show only available and visible characters
    this.characters = this.characters.filter(character => this.excludeIds.indexOf(character.id) === -1) // Exclude characters with specific ids

    this.render()
  }

  render() {
    this.swiperContainer.setAttribute('hidden', 'hidden')

    if (this.slideContainer.children.length) {
      ;[...this.slideContainer.children].forEach(child => child.remove())
    }

    this.characters.forEach(character => {
      const clone = this.template.content.cloneNode(true)

      const mappings = [
        { selector: '.character-card', values: { id: `character-card-${character.id}`, href: character.url } },
        { selector: '.character-card__image', values: { src: character.image, alt: character.title, loading: 'auto' } },
        { selector: '.character-card__title', values: { textContent: character.title } },
        { selector: '.character-card__description', values: { textContent: character.description } },
      ]

      applyMappingsToClone(mappings, clone)

      this.slideContainer.appendChild(clone)
      this.swiperContainer.removeAttribute('hidden')
    })

    if (this.swiper) {
      this.swiper.update()
    } else {
      this.swiper = new Swiper(this.swiperContainer, this.swiperOptions)
    }
  }
}

window.addEventListener('init-load', () => loadComponent(document, 'character-card-carousel', CharacterCardCarouselComponent))
